import { Phone, MessageCircle, Facebook, Instagram, MapPin, Clock } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import {
    PHONE,
    WHATSAPP_URL,
    FACEBOOK_URL,
    INSTAGRAM_URL,
    ADDRESS,
    SCHEDULE,
} from "../../data/site";

const contacts = [
    { icon: Phone, label: "Telefon", value: PHONE.display, href: `tel:${PHONE.raw}`, testid: "contact-phone" },
    { icon: MessageCircle, label: "WhatsApp", value: "Scrie-ne pe WhatsApp", href: WHATSAPP_URL, testid: "contact-whatsapp" },
    { icon: Facebook, label: "Facebook", value: "GAN BARBERSHOP", href: FACEBOOK_URL, testid: "contact-facebook" },
    { icon: Instagram, label: "Instagram", value: "@ganbarbershop", href: INSTAGRAM_URL, testid: "contact-instagram" },
];

export const Contact = () => {
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="relative border-t border-white/10 bg-[#0a0a0a] py-24 text-white md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20">
                    {/* Contact channels */}
                    <div className="lg:col-span-7">
                        <Reveal>
                            <Kicker>Contact</Kicker>
                        </Reveal>
                        <Reveal delay={0.05}>
                            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
                                Hai să <span className="text-gold">vorbim</span>
                            </h2>
                        </Reveal>

                        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2">
                            {contacts.map((c) => (
                                <a
                                    key={c.label}
                                    data-testid={c.testid}
                                    href={c.href}
                                    target={c.href.startsWith("http") ? "_blank" : undefined}
                                    rel="noopener noreferrer"
                                    className="group flex items-center gap-4 bg-[#0a0a0a] p-6 transition-colors duration-300 hover:bg-[#141414]"
                                >
                                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-white/10 text-gold transition-colors duration-300 group-hover:border-gold">
                                        <c.icon size={19} strokeWidth={1.5} />
                                    </span>
                                    <span className="min-w-0">
                                        <span className="block font-body text-xs uppercase tracking-widest text-neutral-500">
                                            {c.label}
                                        </span>
                                        <span className="block truncate font-display text-lg text-white">
                                            {c.value}
                                        </span>
                                    </span>
                                </a>
                            ))}
                        </div>

                        <Reveal delay={0.1}>
                            <div className="mt-8 flex items-start gap-3 text-neutral-300">
                                <MapPin size={20} className="mt-0.5 text-gold" strokeWidth={1.5} />
                                <span className="font-body">{ADDRESS}</span>
                            </div>
                        </Reveal>
                    </div>

                    {/* Schedule */}
                    <div className="lg:col-span-5">
                        <Reveal delay={0.1}>
                            <div className="rounded-2xl border border-white/10 p-8 md:p-10">
                                <div className="flex items-center gap-3">
                                    <Clock size={20} className="text-gold" strokeWidth={1.5} />
                                    <h3 className="font-display text-2xl font-medium tracking-tight">
                                        Program
                                    </h3>
                                </div>
                                <ul className="mt-8 flex flex-col divide-y divide-white/10">
                                    {SCHEDULE.map((s) => (
                                        <li
                                            key={s.day}
                                            data-testid={`schedule-${s.day}`}
                                            className="flex items-center justify-between py-4"
                                        >
                                            <span className="font-body text-neutral-300">
                                                {s.day}
                                            </span>
                                            <span
                                                className={`font-display text-lg ${
                                                    s.closed ? "text-neutral-500" : "text-white"
                                                }`}
                                            >
                                                {s.hours}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                                <a
                                    data-testid="contact-call-btn"
                                    href={`tel:${PHONE.raw}`}
                                    className="mt-8 inline-flex w-full items-center justify-center gap-2.5 rounded-full bg-gold px-6 py-4 font-body text-sm font-semibold text-black transition-transform duration-300 hover:scale-[0.98]"
                                >
                                    <Phone size={16} strokeWidth={2} />
                                    Sună acum
                                </a>
                            </div>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
